import axios from "axios";
import React from "react";
import { Can, getToken } from "../../../service/service";
import Config from "../../../config";
import qs from "qs";

export enum SHOW_MODAL {
    TABLE,
    TREE
}

export interface NavItemProps {
    id: string;
    courseno: string; //课程编号
    courseseq: string; //课程名称
    coursename: string; //课程名称
    customerCode: string; //用户代码
    batchNo: string; //学期编号
    teacherName: string; //授课老师姓名
    teacherId: string; //授课老师id
}

export interface NavListItem {
    batchName: string; //学期名称
    batchNo: string; //学期编号
    courseDomains: NavItemProps[];
}

export interface NavProps {
    keyword?: string;
}

//获取左侧导航列表
export function findTermCourseTreeList(params: NavProps) {
    return axios
        .get<SuccessData<NavListItem[]>>(
            "/teacher/chapter/findTermCourseTreeList",
            { params }
        )
        .then(res => res.data.data);
}

export interface SourceProps {
    delStatus: string; // 是否显示从课件中删除的 '' 1 2
    batchNo: string | undefined; //学期编号
    courseNo: string; // 课程编号
    courseSeq: string; // 课程序号
    weektimeId?: number; // 计划id
    pageNo?: number; // 页码
    pageSize?: number; // 页面尺寸
    keyword?: string; // 关键字
    sourceFileEntity?: {
        useType: string;
    };
}

export interface SourceFile {
    id: number; // 文件id
    description: string; //简介
    fileCode: string; // 资源唯一标识
    fileName: string; // 文件名
    fileSize: string; //
    fileType: string; //后缀
    viewUrl: string; //浏览url
    officeViewUrl: string; //office浏览url
    storePath: string; //
    useType: string; //0本地 //1保利威 2//网页
}

export enum nodeType {
    Chapter = "0",
    Courseware = "1"
}

export interface SourceItem {
    weektimeId: number;
    id: number;
    nodeType: nodeType;
    key: string;
    createTime: string; //创建时间
    createUserName: string; //创建人
    batchNo: string; //学期编号
    batchName: string; //学期名称
    courseName: string; //课程名称
    courseNo: string; //课程变好
    courseSeq: string; //课程seq
    description: string; //说明
    isPublish: number; //发布 0:未发布 1：已发布
    isDownload: number; //下载权限 0：不可下载 1：可以下载
    level: number;
    ownerChapter: {
        id: number;
        chapterName: string; //章节名称
    } | null;
    dcCoursewareSourceStatics: {
        totalNumber: number; //统计人数
        hasLearnNumber: number; //已
        notLearnNumber: number; //未
    };
    sourceFileEntity: SourceFile;
}

export interface SourceDataProps {
    totalSize: number;
    data: SourceItem[];
}

//获取资源列表 表格
export function getSourceList(data: SourceProps) {
    return axios
        .post<SuccessData<SourceDataProps>>("/teacher/chapter/getSourceList", {
            dcCoursewareSourceParam: data
        })
        .then(res => res.data.data);
}

export interface DeleteProps {
    sourceId: React.Key; //课件id:type为1时该属性不能为空
    type: string; //删除类型：0：章节、1：课件
    deleteFromSource: string;
}

//删除节点或课件
export function deleteSource(data: DeleteProps[]) {
    return axios
        .post("/teacher/chapter/deleteChapterOrSourceBatch", data)
        .then(res => res.data.data);
}

export interface UpdateSourceNameProps {
    sourceId: number;
    sourceName: string;
    courseNo: string;
    courseSeq: string;
    batchNo: string | undefined;
}

//重命名
export function updateSourceName(data: UpdateSourceNameProps) {
    return axios
        .post("/teacher/chapter/updateSourceName?" + qs.stringify(data))
        .then(res => res.data.data);
}

export interface UpdateSourceProps {
    id: number;
    weektimeId: number;
    courseNo: string;
    courseSeq: string;
    chapterId: string;
    description: string;
    batchNo: string | undefined;
    isPublish: Can;
    isDownload: Can;
}

//修改设置
export function updateCoursewareSourceBase(data: UpdateSourceProps) {
    return axios
        .post(
            "/teacher/coursewareSource/updateCoursewareSourceBase",
            qs.stringify(data)
        )
        .then(res => res.data.data);
}

export interface DownloadProps {
    fileId: number;
}

//下载
export function downloadCourseWare(params: DownloadProps) {
    const token = getToken();

    window.open(
        `${Config.ApiHost}teacher/coursewareSource/downloadCourseWare?fileId=${
            params.fileId
        }&token=${encodeURIComponent(token!)}`
    );
}
